import type { PageStateModel } from '@sosocio/creator-types/project';

/**
 * Prefix used for viewing-only fixed pages that must not be persisted in
 * `pageList`.
 */
export const BACKEND_ONLY_FIXED_PAGE_ID_PREFIX = 'backendOnlyFixedPage:';

/**
 * Slice of the page state a viewing-only fixed page carries.
 */
export type BackendOnlyFixedPageStateModel = Pick<PageStateModel, 'id' | 'pageModel' | 'serialnumber'>;
